(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bogo-banner"] && !Shopify.designMode) return;
  try {
    (function () {
function init(root) {
      (root || document).querySelectorAll('[data-pm-bogo-duo]').forEach(function (el) {
if (el.dataset.pmReady) return;
el.dataset.pmReady = '1';
el.addEventListener('click', function () {
var form = el.closest('form');
if (!form) return;
var duo = form.querySelector('input[name="pm_mode"][value="duo"]');
if (duo) {
duo.checked = true;
duo.dispatchEvent(new Event('change', { bubbles: true }));
var variants = form.querySelector('[data-pm-variants]');
if (variants && variants.scrollIntoView) {
variants.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        });
      });
    }
if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', function () { init(); });
document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-geschenk"] && !Shopify.designMode) return;
  try {
    (function () {
    function fmt(cents, format) {
      var f = format || '{{amount}}';
      var m = f.match(/\{\{\s*(\w+)\s*\}\}/); var token = m ? m[1] : 'amount';
      function d(n, prec, th, dec) { n = (n / 100).toFixed(prec); var p = n.split('.'); return p[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th) + (p[1] ? dec + p[1] : ''); }
      var v;
      switch (token) {
        case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
        case 'amount_with_space_separator': v = d(cents, 2, ' ', ','); break;
        default: v = d(cents, 2, ',', '.');
      }
      return f.replace(/\{\{\s*\w+\s*\}\}/, v);
    }
    function fmtShort(cents, format) { return fmt(cents, format).replace(/[.,]00(?=\D|$)/, ''); }
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function init(root) {
      if (root.dataset.pgReady) return; root.dataset.pgReady = '1';
      var data = JSON.parse(root.querySelector('[data-pg-data]').textContent);
      function saveAmount(cents) { var e = cents / 100, m = data.savingsRound || 'ab'; var r = m === 'auf' ? Math.ceil(e) : (m === 'nah' ? Math.round(e) : Math.floor(e)); return Math.max(0, r) * 100; }
      var T = data.texts;
      var form = root.closest('form');
      var section = root.closest('[data-pm-section]') || document;
      var money = data.moneyFormat;
      function igReady() { return !!(window.igData && window.igData.price && typeof window.igData.price.getPriceByVariantId === 'function'); }
      function igCents(p) { if (p == null || p === '') return null; var n = Math.round(parseFloat(String(p).replace(',', '.')) * 100); return isNaN(n) ? null : n; }
      function igVar(id, cents) { if (!igReady() || !id) return cents; try { var n = igCents(window.igData.price.getPriceByVariantId(String(id))); return n == null ? cents : n; } catch (e) { return cents; } }
      function igProd(pid, cents) { if (!igReady() || !pid) return cents; try { var n = igCents(window.igData.price.getMinPriceByProductId(String(pid))); return n == null ? cents : n; } catch (e) { return cents; } }
      function igCmp(id, cents) { if (!igReady() || !id || typeof window.igData.price.getComparePriceByVariantId !== 'function') return cents; try { var n = igCents(window.igData.price.getComparePriceByVariantId(String(id))); return n == null ? cents : n; } catch (e) { return cents; } }
      var pieces = {}; data.pieces.forEach(function (p) { pieces[p.handle] = p; });
      pieces[data.ring.handle] = Object.assign({}, pieces[data.ring.handle] || {}, data.ring);
      var MONTHS_DE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
      var COLORS_DE = ['Gold', 'Silber', 'Roségold'];
      var monthLoc = String(T.monthLabels || '').split(/\s*,\s*/), colorLoc = String(T.colorLabels || '').split(/\s*\|\s*/);
      var months = (data.months || []).slice().sort(function (a, b) { return a.order - b.order; }).map(function (m) { var k = (+m.order || 0) - 1; var de = MONTHS_DE[k] || m.name; return { name: de, label: monthLoc[k] || de, order: m.order }; });
      function monthLabel(v) { var k = MONTHS_DE.indexOf(v); return k >= 0 && monthLoc[k] ? monthLoc[k] : (v || ''); }
      function colorLabel(v) { var k = COLORS_DE.indexOf(v); if (k >= 0 && colorLoc[k]) return colorLoc[k]; var c = (data.ring.colors || []).filter(function (x) { return x.name === v; })[0]; return c && c.label ? c.label : (v || ''); }
      var stepsEl = root.querySelector('[data-pg-steps]');
      var afterEls = Array.prototype.slice.call(root.querySelectorAll('[data-pg-after]')); var sib = root.nextElementSibling; if (sib && sib.hasAttribute('data-pg-after')) afterEls.push(sib);
      function syncAfter() { var show = state.revealed || root.dataset.belowMode === 'immer'; afterEls.forEach(function (el) { el.hidden = !show; }); }

      var state = { size: root.dataset.defaultSize || 'duo', slots: [], revealed: root.dataset.stepsMode === 'sofort', chosen: false };
      function piece(h) { return pieces[h] || data.ring; }
      function defaultSizeValue(sizes) { var m = sizes.filter(function (x) { return /^M\b/.test(x); }); return m.length ? m[0] : sizes[0]; }
      function newSlot(h) {
        var p = piece(h);
        return { handle: p.handle, color: (p.colors && p.colors.length) ? p.colors[0].name : null, size: (p.sizes && p.sizes.length) ? defaultSizeValue(p.sizes) : null, i1: '', i2: '', s1: '', s2: '', name: '' };
      }
      state.slots = [newSlot(data.ring.handle)];
      (function () { var own = (data.ring.colors || []).filter(function (c) { return c.handle === data.ring.handle; })[0]; if (own) state.slots[0].color = own.name; })();
      state.addon = { on: false, s1: '', s2: '' }; var addonShown = false, lastFin = false;
      state.extra = { duo: [newSlot(data.defaults.duo[0] || data.ring.handle)], box: [newSlot(data.defaults.box[0] || data.ring.handle), newSlot(data.defaults.box[1] || data.ring.handle)] };
      function extraFor(size) { return size === 'ring' ? [] : state.extra[size]; }
      function slotAt(i, size) { size = size || state.size; return i === 0 ? state.slots[0] : extraFor(size)[i - 1]; }
      var activeSlots = function () { return state.size === 'ring' ? 1 : state.size === 'duo' ? 2 : 3; };

      // ---------- Preise ----------
      function duoVariant() {
        if (!data.duo) return null;
        var second = !data.duoOther || state.extra.duo[0].handle === data.ring.handle;
        var ringV = data.duo.variants.filter(function (v) { return v.title === data.duoRingTitle; })[0] || data.duo.variants[0];
        var other = data.duo.variants.filter(function (v) { return !ringV || v.id !== ringV.id; })[0] || ringV;
        return second ? (ringV || other) : (other || ringV);
      }
      function ringVariant() {
        var sl = state.slots[0]; var c = (data.ring.colors || []).filter(function (x) { return x.name === sl.color; })[0] || data.ring.colors[0];
        if (c && c.vars && sl.size && c.vars[sl.size]) return Object.assign({}, c, { id: c.vars[sl.size] });
        return c;
      }
      function mainHandle() { var c = ringVariant(); return (c && c.handle) || data.ring.handle; }
      function totalFor(size) {
        if (size === 'ring') { var rv = ringVariant(); return igVar(rv.id, rv.price); }
        if (size === 'duo') { var v = duoVariant(); return v ? igVar(v.id, v.price) : null; }
        return data.box ? igVar(data.box.id, data.box.price) : null;
      }
      function singleFor(size) {
        var n = size === 'ring' ? 1 : size === 'duo' ? 2 : 3, sum = 0;
        for (var i = 0; i < n; i++) { var pc = piece(slotAt(i, size).handle); sum += (pc.handle === data.ring.handle ? igVar(ringVariant().id, ringVariant().price) : igProd(pc.pid, pc.price)) || 0; }
        return sum;
      }
      function minRingPrice() { var best = null; (data.ring.colors || []).forEach(function (c) { var v = igVar(c.id, c.price); if (best == null || v < best) best = v; }); return best == null ? data.ring.price : best; }
      function prefixWord() { return String(data.pricePrefix || '').trim(); }
      function ringCompare() { var rv = ringVariant(); return igCmp(rv.id, rv.compare || 0) || 0; }
      function bundleCompare(size) { if (size === 'duo') { var dv = duoVariant(); return dv ? (igCmp(dv.id, dv.compare || 0) || 0) : 0; } return data.box ? (igCmp(data.box.id, data.box.compare || 0) || 0) : 0; }
      function compareFor(size) { if (size === 'ring') return ringCompare(); if (data.bundleCompare !== 'einzeln') { var bc = bundleCompare(size); if (bc > 0) return bc; } return singleFor(size); }
      function lineSize() { return state.chosen ? state.size : 'ring'; }

      // ---------- Zusatz nach „Fertig“ (v3.35) ----------
      var addonEl = root.querySelector('[data-pg-add]');
      var PV = (function () { try { var c = document.querySelector('script[data-pm-preview-config]'); return c ? JSON.parse(c.textContent) : null; } catch (e) { return null; } })() || {};
      var PV_NAMES = {}; String(PV.stoneNames || '').split(/\r?\n/).forEach(function (l) { var i = l.indexOf('='); if (i > 0) PV_NAMES[l.slice(0, i).trim()] = l.slice(i + 1).trim(); });
      function addonTiles() {
        var silver = state.slots[0] && state.slots[0].color === 'Silber', metal = silver ? 'silber' : 'gold';
        var zs = (PV.stones && PV.stones.zia) || {}, labels = PV.stoneLabels || [T.addonM1 || '', T.addonM2 || ''], size = PV.stoneSize || 56;
        var html = '<div class="pvt" style="--pv-radius:' + (PV.radius != null ? PV.radius : 8) + 'px;--pvt-zoom:' + (PV.stoneZoom || 1.25) + ';--pvt-bg:' + (PV.stoneBg || '#F7F4EE') + ';--pvt-size:' + size + 'px">';
        [1, 2].forEach(function (k) {
          var val = state.addon['s' + k], n = MONTHS_DE.indexOf(val) + 1, nn = n ? (n < 10 ? '0' + n : '' + n) : '04';
          var shape = ((zs['s' + k] || {}).shape) === 'emerald' ? 'rechteck' : 'tropfen';
          var img = PV.stoneBase ? '<span class="pvt__img"><img src="' + esc(PV.stoneBase + shape + '-' + metal + '-' + nn + '.png?width=240') + '" alt="" loading="lazy"></span>' : '';
          var name = n ? (PV_NAMES[nn] || PV_NAMES[String(n)] || '') : '';
          html += '<div class="pvt__tile' + (n ? '' : ' is-ph') + '">' + img + '<span class="pvt__tx">' + (labels[k - 1] ? '<small>' + esc(labels[k - 1]) + '</small>' : '') + '<b>' + esc(n ? monthLabel(val) : (PV.stonePh || T.addonPick || '')) + '</b>' + (name ? '<span>' + esc(name) + '</span>' : '') + '</span></div>';
        });
        return { html: html + '</div>', h: size + 12 };
      }
      function addonAvail() { return !!(addonEl && data.addon && data.addon.variants && data.addon.variants.length && data.addon.on && data.addon.on[state.size]); }
      function addonVariant() { if (!data.addon) return null; var vs = data.addon.variants; var silver = state.slots[0] && state.slots[0].color === 'Silber'; return silver && vs[1] ? vs[1] : vs[0]; }
      function addonActive() { return addonShown && state.addon.on && addonAvail(); }
      function addonCents() { var v = addonVariant(); return v ? igVar(v.id, v.price) : 0; }
      function btnPrice() { var t = totalFor(state.size); if (addonActive() && t != null) return fmt(t + addonCents(), money); return priceText(state.size); }
      function fillMonths() {
        if (!addonEl) return;
        addonEl.querySelectorAll('[data-pg-add-month]').forEach(function (sel) {
          if (sel.options.length) return;
          var o = document.createElement('option'); o.value = ''; o.textContent = T.addonPick || ''; sel.appendChild(o);
          months.forEach(function (m) { var op = document.createElement('option'); op.value = m.name; op.textContent = m.label; sel.appendChild(op); });
        });
      }
      function renderAddon(fin) {
        if (!addonEl) return;
        var show = addonAvail() && state.revealed && (!flow || fin);
        addonShown = show; addonEl.hidden = !show; if (!show) return;
        fillMonths();
        var v = addonVariant(), on = state.addon.on;
        addonEl.classList.toggle('is-on', on);
        var tg = addonEl.querySelector('[data-pg-add-toggle]'); if (tg) tg.setAttribute('aria-checked', on ? 'true' : 'false');
        var img = addonEl.querySelector('[data-pg-add-img]'); if (img && v && v.image) { if (img.getAttribute('src') !== v.image) img.setAttribute('src', v.image); img.hidden = false; }
        var cents = addonCents(), cmp = v ? igCmp(v.id, v.compare || 0) : 0;
        var pr = addonEl.querySelector('[data-pg-add-price]'); if (pr) pr.textContent = (pr.hasAttribute('data-plain') ? '' : '+') + fmt(cents, money);
        var cp = addonEl.querySelector('[data-pg-add-compare]'); if (cp) { cp.hidden = !(cmp > cents); cp.textContent = cmp > cents ? fmt(cmp, money) : ''; }
        var st = addonEl.querySelector('[data-pg-add-stones]'); if (st) st.hidden = !on;
        [1, 2].forEach(function (k) { var sel = addonEl.querySelector('[data-pg-add-month="' + k + '"]'), val = state.addon['s' + k]; if (sel && sel.value !== val) sel.value = val; });
        var tw = addonEl.querySelector('[data-pg-add-tiles]'); if (tw && on) { var tl = addonTiles(); if (tw.getAttribute('data-sig') !== tl.html) { tw.setAttribute('data-sig', tl.html); tw.innerHTML = tl.html; } var stw = addonEl.querySelector('[data-pg-add-stones]'); if (stw) stw.style.setProperty('--pvt-h', tl.h + 'px'); }
        var sv = addonEl.querySelector('[data-pg-add-save]'), amt = cmp > cents ? saveAmount(cmp - cents) : 0;
        if (sv) { var ready = on && state.addon.s1 && state.addon.s2 && amt > 0; sv.hidden = !ready; var sa = sv.querySelector('[data-pg-add-save-amt]'); if (sa) sa.textContent = ready ? String(T.addonSave || '').replace('{amount}', fmtShort(amt, money)) : ''; }
      }
      function addonError(msg) {
        if (!addonEl) return;
        var er = addonEl.querySelector('[data-pg-add-err]'); if (er) { er.textContent = msg || ''; er.hidden = !msg; }
        [1, 2].forEach(function (k) { var sel = addonEl.querySelector('[data-pg-add-month="' + k + '"]'); if (sel) sel.setAttribute('aria-invalid', (!!msg && !state.addon['s' + k]) ? 'true' : 'false'); });
      }
      function toggleAddon() {
        state.addon.on = !state.addon.on; addonError(''); renderAddon(lastFin); renderTotals();
        if (state.addon.on && !state.addon.s1) { var f = addonEl.querySelector('[data-pg-add-month="1"]'); if (f) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 60); }
      }
      if (addonEl) {
        addonEl.addEventListener('click', function (e) { if (e.target.closest('[data-pg-add-toggle]')) { e.preventDefault(); toggleAddon(); } });
        addonEl.addEventListener('keydown', function (e) { if ((e.key === ' ' || e.key === 'Enter') && e.target.closest('[data-pg-add-toggle]')) { e.preventDefault(); toggleAddon(); } });
        function onMonth(e) { var t = e.target; if (!t.hasAttribute('data-pg-add-month')) return; e.stopPropagation(); state.addon['s' + t.getAttribute('data-pg-add-month')] = t.value;
          var er = addonEl.querySelector('[data-pg-add-err]'); if (state.addon.s1 && state.addon.s2) addonError(''); else if (er && !er.hidden) addonError(T.addonNeed); renderAddon(lastFin); renderTotals(); }
        addonEl.addEventListener('input', onMonth); addonEl.addEventListener('change', onMonth);
      }
      function headlineText() { if (!state.chosen) { var pfx = prefixWord(); if (pfx) return pfx + ' ' + fmt(minRingPrice(), money); return priceText('ring'); } return priceText(state.size); }
      function wantSingle() { return data.savings === 'einzeln' || data.savings === 'beides'; }
      function wantTag() { return data.savings === 'betrag' || data.savings === 'beides'; }
      function fallbackFor(size) { if (size === 'duo') return state.extra.duo[0].handle === data.ring.handle ? T.fallback.duo : T.fallback.duo2; return T.fallback.box; }
      function priceText(size) { var c = totalFor(size); return c == null ? fallbackFor(size) : fmt(c, money); }
      function fallbackCents(size) { var m = String(fallbackFor(size) || '').replace(/[^0-9.,]/g, ''); if (!m) return null; var n = Math.round(parseFloat(m.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.')) * 100); return isNaN(n) ? null : n; }
      function effectiveTotal(size) { var c = totalFor(size); return c == null ? fallbackCents(size) : c; }

      // ---------- Rendering ----------
      function renderCards() {
        ['ring', 'duo', 'box'].forEach(function (size) {
          var c = root.querySelector('[data-pg-card="' + size + '"]'); if (!c) return;
          var on = size === state.size; c.classList.toggle('is-on', on); var inp = c.querySelector('input'); if (inp) inp.checked = on;
          var pEl = c.querySelector('[data-pg-card-price]'); if (pEl) pEl.textContent = priceText(size);
          var sEl = c.querySelector('[data-pg-card-single]'), vEl = c.querySelector('[data-pg-card-save]');
          var single = compareFor(size), total = effectiveTotal(size), saves = total != null && single > total;
          if (sEl) { var show = size === 'ring' ? (data.ringSavings !== false && saves && wantSingle()) : ((total == null || saves) && wantSingle()); sEl.hidden = !show; sEl.textContent = show ? ((size === 'ring' ? '' : T.single + ' ') + fmt(single, money)) : ''; }
          if (vEl) { var amt = saves ? saveAmount(single - total) : 0, showTag = saves && wantTag() && amt > 0 && (size !== 'ring' || (data.ringSavings !== false && data.ringTag !== false)); vEl.hidden = !showTag; vEl.textContent = showTag ? (data.savingsTpl || 'Spare {amount}').replace('{amount}', fmtShort(amt, money)) : ''; }
        });
        var n = activeSlots();
        root.querySelectorAll('[data-pg-slot]').forEach(function (el, i) { el.hidden = i >= n; });
        if (stepsEl) stepsEl.hidden = !state.revealed;
      }

      function slotHtml(i) {
        var sl = slotAt(i), p = piece(sl.handle), n = activeSlots();
        var changeable = state.size === 'box' ? !(i === 0 && data.boxRingFixed) : (i > 0 && !!data.duoOther);
        var boxAlt = state.size === 'box' && i > 0 && changeable && T.changeBox && T.changeBox[i];
        var isRec = state.size === 'box' && i > 0 && data.defaults && data.defaults.box && sl.handle === data.defaults.box[i - 1] && T.recBadge;
        var title = titleFor(i);
        var h = '<div class="pg-sum"><span class="pg-sum__ic"><svg viewBox=\"0 0 16 16\" aria-hidden=\"true\"><path d=\"M3.5 8.5l3 3 6-7\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></span><span class="pg-sum__t"><small>' + esc(title) + '</small><b data-pg-sum-text="' + i + '"></b></span><button type="button" class="pg-sum__edit" data-pg-edit="' + i + '">' + esc(T.flowEdit) + '</button></div>';
        var big = state.size === 'box' && i > 0 && p.big;
        h += '<div class="pg-slot__head' + (big ? ' pg-slot__head--big' : '') + '">' + (n > 1 ? '<span class="pg-slot__num">' + (i + 1) + '</span>' : '') + (p.image ? '<img src="' + esc(big ? p.big : p.image) + '" alt=""' + (big ? ' data-pg-look="' + i + '" role="button" tabindex="0"' : '') + '>' : '') + '<span class="pg-slot__title">' + (title ? '<small>' + esc(title) + (isRec ? ' <em class="pg-rec">' + esc(T.recBadge) + '</em>' : '') + '</small>' : '') + '<b>' + esc(p.label) + '</b>' + (big && T.look ? '<button type="button" class="pg-look" data-pg-look="' + i + '">' + esc(T.look) + '</button>' : '') + '</span>' + (n > 1 && (state.size === 'duo' ? T.slotPriceDuo : T.slotPriceBox) ? '<span class="pg-slot__price">' + fmt(p.price, money) + '</span>' : '') + (changeable && !boxAlt ? '<button type="button" class="pg-slot__change" data-pg-change="' + i + '">' + esc(T.change) + '</button>' : '') + '</div>';
        var preview = '<div class="pg-preview" data-pg-preview-slot="' + i + '" data-pg-preview-type="' + esc(p.type) + '" data-pg-preview-handle="' + esc(sl.handle) + '"></div>';
        var f = '';
        var cols = (p.colors || []).filter(function (c) { return c && c.name && c.name !== 'Default Title'; });
        if (cols.length > 1) {
          f += '<div class="pg-colors"><span class="pg-lbl pg-lbl--inline">' + esc(T.colorLabel) + '</span><span hidden data-pg-colorname="' + i + '">' + esc(colorLabel(sl.color)) + '</span><div class="pg-swatches">';
          cols.forEach(function (c) { f += '<label class="pg-swatch" title="' + esc(colorLabel(c.name)) + '"><input type="radio" name="pg_color_' + i + '" value="' + esc(c.name) + '"' + (c.name === sl.color ? ' checked' : '') + ' data-pg-color="' + i + '"><span class="pg-swatch__dot" data-color="' + esc(c.name.toLowerCase()) + '"></span></label>'; });
          f += '</div></div>';
        }
        if (p.sizes && p.sizes.length) {
          f += '<div class="pg-size"><span class="pg-lbl pg-lbl--inline">' + esc(T.sizeLabel) + '</span><select class="pg-select" data-pg-size="' + i + '" aria-label="' + esc(T.sizeLabel) + '">';
          p.sizes.forEach(function (sz) { f += '<option value="' + esc(sz) + '"' + (sz === sl.size ? ' selected' : '') + '>' + esc(sz) + '</option>'; });
          f += '</select></div>';
        }
        if (p.type === 'initials') {
          f += '<div class="pg-initials"><span class="pg-lbl pg-lbl--inline">' + esc(T.initialsLabel) + '</span><input type="text" class="pg-field" maxlength="1" autocomplete="off" placeholder="A" aria-label="1. Initiale" data-pg-initial="' + i + '-1" value="' + esc(sl.i1) + '"><input type="text" class="pg-field" maxlength="1" autocomplete="off" placeholder="B" aria-label="2. Initiale" data-pg-initial="' + i + '-2" value="' + esc(sl.i2) + '"></div></div>';
          f += preview;
        } else if (p.type === 'stones') {
          var opts1 = '<option value="" disabled hidden>' + esc(T.stone1) + '</option>', opts2 = '<option value="" disabled hidden>' + esc(T.stone2) + '</option>', optsM = '';
          months.forEach(function (m) { optsM += '<option value="' + esc(m.name) + '">' + esc(m.label) + '</option>'; });
          f += '<div class="pg-st"><div class="pg-two"><select class="pg-select" data-pg-stone="' + i + '-1" aria-label="' + esc(T.stone1) + '">' + (opts1 + optsM).replace('value="' + esc(sl.s1) + '"', 'value="' + esc(sl.s1) + '" selected') + '</select><select class="pg-select" data-pg-stone="' + i + '-2" aria-label="' + esc(T.stone2) + '">' + (opts2 + optsM).replace('value="' + esc(sl.s2) + '"', 'value="' + esc(sl.s2) + '" selected') + '</select></div>' + preview + '</div>';
        } else if (p.type === 'name') {
          f += '<div class="pg-namef"><span class="pg-lbl pg-lbl--inline">' + esc(T.nameLabel) + '</span><input type="text" class="pg-text" maxlength="' + (p.nameMax || 12) + '" autocomplete="off" placeholder="z. B. Emma" aria-label="' + esc(T.nameLabel) + '" data-pg-name="' + i + '" value="' + esc(sl.name) + '"></div>';
          f += preview;
        }
        if (f) h += '<div class="pg-fields">' + f + '</div>';
        if (boxAlt) h += '<button type="button" class="pg-slot__alt" data-pg-change="' + i + '">' + esc(T.changeBox[i]) + '</button>';
        if (flow) h += '<button type="button" class="pg-next" data-pg-next="' + i + '">' + esc(i < n - 1 ? String(T.flowNext || '').replace('{x}', titleFor(i + 1)) : (T.flowFinish || '')) + '</button>';
        return h;
      }
      function renderSlot(i) { var el = root.querySelector('[data-pg-slot="' + i + '"]'); if (el) el.innerHTML = slotHtml(i); if (typeof syncSteps === 'function' && flow) syncSteps(); }
      function syncMirror(fromInput) {
        if (!data.mirror || state.size !== 'duo') return;
        var a = state.slots[0], b = state.extra.duo[0];
        if (!b || b.handle !== data.ring.handle || b.mirror === false) return;
        b.i1 = a.i1; b.i2 = a.i2;
        var e1 = root.querySelector('[data-pg-initial="1-1"]'), e2 = root.querySelector('[data-pg-initial="1-2"]');
        if (e1 && e1.value !== b.i1) { e1.value = b.i1; if (b.i1) e1.setAttribute('aria-invalid', 'false'); }
        if (e2 && e2.value !== b.i2) { e2.value = b.i2; if (b.i2) e2.setAttribute('aria-invalid', 'false'); }
      }
      function slotsDetail() { var arr = []; for (var i = 0; i < activeSlots(); i++) { var sl = slotAt(i), p = piece(sl.handle); arr.push({ i: i, handle: (i === 0 && sl.handle === data.ring.handle) ? mainHandle() : sl.handle, type: p.type, color: sl.color || '', i1: sl.i1 || '', i2: sl.i2 || '', s1: sl.s1 || '', s2: sl.s2 || '', name: sl.name || '', size: sl.size || '' }); } return { size: state.size, revealed: state.revealed, slots: arr }; }
      function emitSlots() { try { document.dispatchEvent(new CustomEvent('pg:slots', { detail: slotsDetail() })); } catch (e) {} }
      function renderAllSlots() { syncMirror(false); for (var i = 0; i < activeSlots(); i++) renderSlot(i); emitSlots(); if (typeof syncSteps === 'function') syncSteps(); }

      // ---------- Das ist drin + Schnellansicht ----------
      function cleanName(l) { return String(l || '').split(' · ')[0].replace(/\s*\(.*\)$/, ''); }
      function renderInside() {
        var el = root.querySelector('[data-pg-inside]'); if (!el) return;
        var show = data.showInside && state.size === 'box' && !state.revealed;
        el.hidden = !show; if (!show) return;
        var items = [{ p: data.ring, img: data.insideImg || data.ring.big || data.ring.image }], sum = data.ring.price || 0;
        (state.extra.box || []).forEach(function (sl) { var pp = piece(sl.handle); items.push({ p: pp, img: pp.big || pp.image }); sum += pp.price || 0; });
        var save = saveAmount(sum - effectiveTotal('box'));
        var html = (T.insideTitle ? '<div class="pg-inside__h">' + esc(T.insideTitle) + '</div>' : '') + '<div class="pg-inside__grid">';
        var labs = String(T.insideLabels || '').split('|').map(function (x) { return x.trim(); });
        var ringC = igVar(ringVariant().id, ringVariant().price) || 0;
        items.forEach(function (it, k) { var pc = k === 0 ? ringC : (igProd(it.p.pid, it.p.price) || 0); html += '<button type="button" class="pg-inside__it"' + (k > 0 ? ' data-pg-look-h="' + esc(it.p.handle) + '"' : '') + '>' + (it.img ? '<img src="' + esc(it.img) + '" alt="">' : '') + ((labs[k] || it.p.short) ? '<span>' + esc(labs[k] || it.p.short) + '</span>' : '') + (T.insidePrices && pc > 0 ? '<s>' + esc(fmt(pc, money)) + '</s>' : '') + '</button>'; });
        html += '</div>';
        var extra = (effectiveTotal('box') || 0) - ringC;
        if (T.insideValue && extra > 0) { var vt = esc(T.insideValue), am = esc(fmtShort(extra, money)); var m = vt.match(/\*([^*]*\{amount\}[^*]*)\*/); html += '<div class="pg-inside__val">' + (m ? vt.replace(m[0], '<b>' + m[1].replace('{amount}', am) + '</b>') : vt.replace('{amount}', '<b>' + am + '</b>')) + '</div>'; }
        if (T.insideSum) html += '<div class="pg-inside__sum"><svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M7 7h11l-3-3M17 17H6l3 3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg><span>' + esc(T.insideSum) + '</span></div>';
        el.innerHTML = html;
      }
      function factsFor(h) {
        var out = []; String(data.facts || '').split(/\r?\n/).forEach(function (line) { var i = line.indexOf('='); if (i < 1) return; var k = line.slice(0, i).trim().toLowerCase(); if (k && String(h).toLowerCase().indexOf(k) === 0 && !out.length) out = line.slice(i + 1).split('|').map(function (x) { return x.trim(); }).filter(Boolean); });
        return out;
      }
      var qv = null;
      function closeQv() { if (!qv) return; qv.remove(); qv = null; document.documentElement.style.overflow = ''; }
      function openQv(handle) {
        var p = piece(handle); if (!p) return; closeQv();
        var imgs = (p.images && p.images.length) ? p.images : (p.big ? [p.big] : []);
        var facts = factsFor(handle);
        qv = document.createElement('div'); qv.className = 'pg-qv';
        var g = '<div class="pg-qv__gal" data-pg-qv-gal>'; imgs.forEach(function (u) { g += '<img src="' + esc(u) + '" alt="" loading="lazy">'; }); g += '</div>';
        var dots = imgs.length > 1 ? '<div class="pg-qv__dots">' + imgs.map(function (_, k) { return '<i' + (k === 0 ? ' class="on"' : '') + '></i>'; }).join('') + '</div>' : '';
        qv.innerHTML = '<div class="pg-qv__bg" data-pg-qv-close></div><div class="pg-qv__panel" role="dialog" aria-modal="true" aria-label="' + esc(cleanName(p.label)) + '"><button type="button" class="pg-qv__x" data-pg-qv-close aria-label="' + esc(T.close || '') + '">×</button>' + g + dots + '<h4>' + esc(p.label) + '</h4>' + (state.size === 'box' && T.valueLine ? '<p class="pg-qv__v">' + String(T.valueLine).replace('{price}', fmt(p.price, money)) + '</p>' : '<p class="pg-qv__v">' + fmt(p.price, money) + '</p>') + (facts.length ? '<ul>' + facts.map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul>' : '') + '<button type="button" class="pg-qv__back" data-pg-qv-close>' + esc(T.qvBack || '') + '</button></div>';
        qv.style.cssText = '--pg-accent:' + getComputedStyle(root).getPropertyValue('--pg-accent');
        document.body.appendChild(qv); document.documentElement.style.overflow = 'hidden';
        qv.addEventListener('click', function (e) { if (e.target.closest('[data-pg-qv-close]')) closeQv(); });
        var gal = qv.querySelector('[data-pg-qv-gal]'); if (gal && dots) gal.addEventListener('scroll', function () { var k = Math.round(gal.scrollLeft / Math.max(1, gal.clientWidth)); qv.querySelectorAll('.pg-qv__dots i').forEach(function (d, j) { d.classList.toggle('on', j === k); }); }, { passive: true });
        var bk = qv.querySelector('.pg-qv__back'); if (bk) setTimeout(function () { try { bk.focus({ preventScroll: true }); } catch (e) {} }, 50);
      }
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQv(); });

      // ---------- Schritt-für-Schritt ----------
      var flow = root.dataset.flow === '1';
      state.step = 0; state.done = [false, false, false];
      function titleFor(j) { var sj = slotAt(j); if (state.size === 'duo' && j === 0 && T.duoSlot1 && piece(data.ring.handle).type === 'initials') return T.duoSlot1; if (state.size === 'duo' && j === 1 && sj && sj.handle === data.ring.handle && T.duoSlot) return T.duoSlot; var tt = T.slotTitles[j] || ''; if (tt.indexOf('{kurz}') >= 0) { var pj = sj ? piece(sj.handle) : null; tt = tt.replace('{kurz}', (pj && pj.short) || ''); } return tt.trim(); }
      function complete(i) { var sl = slotAt(i); if (!sl) return true; var p = piece(sl.handle); if (p.type === 'initials') return !!(sl.i1 && sl.i2); if (p.type === 'stones') return !!(sl.s1 && sl.s2); if (p.type === 'name') return !!String(sl.name || '').trim(); return true; }
      function noChoice() { if (state.size !== 'ring') return false; var p = piece(state.slots[0].handle); var cols = (p.colors || []).filter(function (c) { return c && c.name && c.name !== 'Default Title'; }); return p.type === 'plain' && cols.length <= 1 && !(p.sizes && p.sizes.length); }
      function allDone() { if (!flow) return true; if (state.revealed && state.step < activeSlots()) return false; for (var i = 0; i < activeSlots(); i++) { if (!state.done[i] || !complete(i)) return false; } return true; }
      function shortName(p) { var l = String(p.label || '').split(' · ')[0]; var w = l.split(' ')[0]; return /initial|mavie/i.test(l) ? '' : w; }
      function slotSummary(i) {
        var sl = slotAt(i), p = piece(sl.handle), parts = [];
        if (p.type === 'initials') { var nm = shortName(p); if (nm) parts.push(nm); if (sl.color) parts.push(colorLabel(sl.color)); parts.push((sl.i1 || '?') + ' & ' + (sl.i2 || '?')); }
        else if (p.type === 'stones') { parts.push(shortName(p) || p.label); if (sl.color && p.colors && p.colors.length > 1) parts.push(colorLabel(sl.color)); parts.push((sl.s1 ? monthLabel(sl.s1) : '?') + ' & ' + (sl.s2 ? monthLabel(sl.s2) : '?')); }
        else if (p.type === 'name') { parts.push(shortName(p) || p.label); parts.push(String(sl.name || '').trim() || '?'); }
        else { parts.push(String(p.label || '').split(' · ')[0]); if (sl.size) parts.push(sl.size); }
        return parts.join(' · ');
      }
      function firstOpen() { for (var i = 0; i < activeSlots(); i++) { if (!state.done[i] || !complete(i)) return i; } return activeSlots(); }
      function syncSteps() {
        var n = activeSlots(), on = flow && state.revealed;
        root.classList.toggle('pg--flow', on);
        var ft = root.querySelector('[data-pg-flowtitle]'), q = root.querySelector('[data-pg-q]'), qs = root.querySelector('[data-pg-qs]'), cards = root.querySelector('.pg-cards'), s0 = root.querySelector('[data-pg-sum0]'), prog = root.querySelector('[data-pg-prog]');
        var boxv = document.documentElement.classList.contains('pm-box') && state.size === 'box' && !state.fromCart;
        if (ft) ft.hidden = !on; if (q) q.hidden = on; if (qs) qs.hidden = on; if (cards) cards.hidden = on; if (s0) s0.hidden = !on || boxv;
        if (s0 && on) { var cb = root.querySelector('[data-pg-card="' + state.size + '"] .pg-card__t b'); var st = s0.querySelector('[data-pg-sum0-text]'); if (st) st.textContent = (cb ? cb.textContent : '') + ' · ' + priceText(state.size); }
        var doneCount = 0; for (var k = 0; k < n; k++) if (state.done[k] && complete(k) && !(on && k === state.step)) doneCount++;
        var fin = on && doneCount === n && state.step >= n;
        if (prog) { prog.hidden = !flow || !state.revealed; var lbl = prog.querySelector('[data-pg-prog-label]'), fill = prog.querySelector('[data-pg-prog-fill]'); var total = boxv ? n : n + 1, cur = !state.revealed ? 1 : Math.min(state.step + (boxv ? 1 : 2), total); if (lbl) lbl.textContent = fin ? (T.flowDone || '') : String(T.flowProg || '').replace('{x}', cur).replace('{n}', total); if (fill) fill.style.width = Math.round(((state.revealed && !boxv ? 1 : 0) + doneCount) / total * 100) + '%'; }
        for (var i = 0; i < 3; i++) {
          var el = root.querySelector('[data-pg-slot="' + i + '"]'); if (!el) continue;
          var act = on && i === state.step, dn = on && !act && state.done[i] && complete(i), upc = on && !act && !dn;
          el.classList.toggle('is-active', act); el.classList.toggle('is-done', dn); el.classList.toggle('is-up', upc);
          var sm = el.querySelector('[data-pg-sum-text]'); if (sm && i < n) sm.textContent = slotSummary(i);
          var nb = el.querySelector('[data-pg-next]'); if (nb) nb.classList.toggle('is-off', !complete(i));
        }
        var rd = root.querySelector('[data-pg-ready]'); if (rd) rd.hidden = !fin; var hn = root.querySelector('[data-pg-hint]'); if (hn) hn.hidden = fin;
        lastFin = fin; renderAddon(fin);
        renderInside();
        var sb = root.querySelector('[data-pg-submit]'); if (sb) sb.classList.toggle('is-locked', on && !fin);
      }
      function validateSlot(i) {
        var sl = slotAt(i), p = piece(sl.handle), firstBad = null, msg = '';
        function bad(el, m) { if (el) el.setAttribute('aria-invalid', 'true'); if (!firstBad) { firstBad = el; msg = m; } }
        if (p.type === 'initials') { if (!sl.i1) bad(root.querySelector('[data-pg-initial="' + i + '-1"]'), T.needInitials); if (!sl.i2) bad(root.querySelector('[data-pg-initial="' + i + '-2"]'), T.needInitials); }
        if (p.type === 'stones') { if (!sl.s1) bad(root.querySelector('[data-pg-stone="' + i + '-1"]'), T.needStones); if (!sl.s2) bad(root.querySelector('[data-pg-stone="' + i + '-2"]'), T.needStones); }
        if (p.type === 'name' && !String(sl.name || '').trim()) bad(root.querySelector('[data-pg-name="' + i + '"]'), T.needName);
        if (firstBad) { showError(msg); try { firstBad.focus({ preventScroll: true }); } catch (e) {} showSlot(i); return false; }
        showError(''); return true;
      }
      function goStep(i) { state.step = i; closePicker(); syncSteps(); renderTotals(); if (i < activeSlots()) { showSlot(i); var f = root.querySelector('[data-pg-slot="' + i + '"] input.pg-field, [data-pg-slot="' + i + '"] .pg-text'); if (f && !f.value) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (e) {} }, 350); } else { var b = root.querySelector('[data-pg-ready]') || root.querySelector('[data-pg-submit]'); if (b) b.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }
      function advance(i) { if (!validateSlot(i)) return; state.done[i] = true; goStep(firstOpen()); }
      root.addEventListener('input', function () { if (flow) syncSteps(); });
      root.addEventListener('change', function () { if (flow) syncSteps(); });

      function renderTotals() {
        var ls = lineSize(), total = effectiveTotal(ls), label = (state.revealed || noChoice()) ? T.btn : T.btnNext;
        var bl = root.querySelector('[data-pg-btn-label]'); if (bl) bl.textContent = label.replace('{price}', btnPrice());
        var pp = form ? form.querySelector('[data-pm-price]') : null; var pc = form ? form.querySelector('[data-pm-compare]') : null; var pb = form ? form.querySelector('[data-pm-sale-badge]') : null;
        if (pp) { pp.textContent = headlineText(); var vid = state.chosen ? variantId() : ringVariant().id; if (vid) pp.setAttribute('data-variant-id', vid); }
        var cmp = compareFor(ls);
        var saves = (state.chosen || !prefixWord()) && total != null && cmp > total;
        var cpx = ls === 'ring' ? '' : (pc ? (pc.getAttribute('data-pm-compare-prefix') || '').trim() : String(T.single || ''));
        var cmpText = (saves && wantSingle()) ? ((cpx ? cpx + ' ' : '') + fmt(cmp, money)) : '';
        var tpl = pb ? (pb.getAttribute('data-pm-badge-template') || '') : (data.savingsTpl || 'Spare {amount}');
        var bAmt = saves ? saveAmount(cmp - total) : 0;
        var badgeText = (saves && wantTag() && bAmt > 0) ? (tpl.indexOf('{amount}') >= 0 ? tpl.replace('{amount}', fmtShort(bAmt, money)) : tpl) : '';
        if (pc) { pc.hidden = !cmpText; pc.textContent = cmpText; }
        if (pb) { pb.hidden = !badgeText; pb.textContent = badgeText; }
        try { document.dispatchEvent(new CustomEvent('pg:state', { detail: { revealed: state.revealed && allDone(), chosen: state.chosen, size: state.size, price: btnPrice(), addon: addonActive(), headline: headlineText(), compare: cmpText, badge: badgeText, ring: state.slots[0].handle === data.ring.handle, color: state.slots[0].color, i1: state.slots[0].i1, i2: state.slots[0].i2 } })); } catch (e) {}
      }
      function renderAll() { renderCards(); renderAllSlots(); renderAddon(flow ? lastFin : true); renderTotals(); renderInside(); }

      // ---------- Picker ----------
      var picker = root.querySelector('[data-pg-picker]'); var pickFor = null;
      function pickBtn(p, cur) { return '<button type="button" class="pg-pick' + (p.handle === cur ? ' is-on' : '') + '" data-pg-pick="' + esc(p.handle) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') + '<b>' + esc(p.label) + '</b>' + (T.pickPrice || state.size !== 'box' ? '<small>' + fmt(p.price, money) + '</small>' : '') + '</button>'; }
      function openPicker(i) {
        pickFor = i; var grid = root.querySelector('[data-pg-picker-grid]'); var cur = slotAt(i).handle; var html = '';
        var list = data.pieces.slice(); if (!data.pieces.some(function (p) { return p.handle === data.ring.handle; })) list.unshift(data.ring);
        var titleEl = root.querySelector('[data-pg-picker-title]'); if (titleEl) { if (!titleEl.dataset.def) titleEl.dataset.def = titleEl.textContent; titleEl.textContent = (state.size === 'box' && T.pickBox && T.pickBox[i]) || titleEl.dataset.def; }
        var kw = state.size === 'box' && data.boxFilter ? String(data.boxFilter[i] || '').toLowerCase().split(',').map(function (x) { return x.trim(); }).filter(Boolean) : [];
        if (kw.length) {
          list = list.filter(function (p) { var t = (String(p.handle) + ' ' + String(p.label)).toLowerCase(); return kw.some(function (k) { return t.indexOf(k) >= 0; }); });
          var pop = String(data.popular || '').split(/\r?\n/).map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
          var top = []; pop.forEach(function (h) { list.forEach(function (p) { if (String(p.handle).toLowerCase() === h && top.indexOf(p) < 0 && top.length < 3) top.push(p); }); });
          var rest = list.filter(function (p) { return top.indexOf(p) < 0; });
          if (top.length) { html += '<div class="pg-pick-sec">' + esc(T.pickPopular || '') + '</div><div class="pg-picker__grid">'; top.forEach(function (p) { html += pickBtn(p, cur); }); html += '</div>'; }
          if (rest.length) { html += '<div class="pg-pick-sec">' + esc((T.pickAll && T.pickAll[i]) || '') + '</div><div class="pg-picker__grid">'; rest.forEach(function (p) { html += pickBtn(p, cur); }); html += '</div>'; }
          grid.classList.add('is-sections');
        } else {
          list.forEach(function (p) { html += pickBtn(p, cur); }); grid.classList.remove('is-sections');
        }
        grid.innerHTML = html; picker.hidden = false;
        var slotEl = root.querySelector('[data-pg-slot="' + i + '"]'); if (slotEl && slotEl.parentNode) slotEl.parentNode.insertBefore(picker, slotEl.nextSibling);
        picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
      function closePicker() { picker.hidden = true; pickFor = null; }
      // Nach Auswahl/Schließen zurück zum geänderten Stück scrollen (der hohe Picker klappt zu, sonst landet man weiter unten)
      function showSlot(i) {
        var el = root.querySelector('[data-pg-slot="' + i + '"]'); if (!el) return;
        var r = el.getBoundingClientRect(); var hh = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
        if (r.top < hh + 8 || r.top > window.innerHeight - 80) window.scrollTo({ top: window.pageYOffset + r.top - hh - (T.backOffset != null ? T.backOffset : 56), behavior: 'smooth' });
      }

      // ---------- Lieferdatum ----------
      (function () {
        var el = root.querySelector('[data-pg-date]'); if (!el) return;
        var lang = (data.lang || 'de').slice(0, 2);
        var M = { de: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'], en: ['January','February','March','April','May','June','July','August','September','October','November','December'], fr: ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'], nl: ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'], it: ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'], es: ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'] };
        var W = { de: ['So','Mo','Di','Mi','Do','Fr','Sa'], en: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'], fr: ['dim.','lun.','mar.','mer.','jeu.','ven.','sam.'], nl: ['zo','ma','di','wo','do','vr','za'], it: ['dom','lun','mar','mer','gio','ven','sab'], es: ['dom','lun','mar','mié','jue','vie','sáb'] };
        var m = M[lang] || M.de; var d = new Date(); d.setDate(d.getDate() + (data.daysMax || 10)); if (d.getDay() === 0) d.setDate(d.getDate() + 1);
        var wd = data.weekday ? ((W[lang] || W.de)[d.getDay()] + ', ') : '';
        el.textContent = wd + (lang === 'de' ? (d.getDate() + '. ' + m[d.getMonth()]) : (d.getDate() + ' ' + m[d.getMonth()]));
      })();

      // ---------- Galerie bei Farbwechsel des Rings ----------
      function switchGallery(colorName) {
        var c = (data.ring.colors || []).filter(function (x) { return x.name === colorName; })[0];
        if (c && !c.media && c.image) { var im = section.querySelector('[data-pm-slide] img'); if (im) { im.removeAttribute('srcset'); im.src = c.image; } var tr = section.querySelector('[data-pm-track]'); if (tr) tr.scrollTo({ left: 0, behavior: 'smooth' }); return; }
        if (!c || !c.media) return;
        var slide = section.querySelector('[data-pm-slide][data-media-id="' + c.media + '"]'); var track = section.querySelector('[data-pm-track]');
        if (slide && track) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }

      // Box: Armband und Kette folgen der Ringfarbe (19.10.2026). Silber → Silber-Stück (Handle mit -1), Gold und Roségold → Gold-Stück.
      // Gewählte Steine und Namen bleiben. Andere Stücke (selbst getauscht, ohne Gegenstück) bleiben unverändert.
      function boxFollowRing(color) {
        var changed = false;
        state.extra.box = state.extra.box.map(function (sl) {
          var h = sl.handle, base = /-1$/.test(h) && pieces[h.slice(0, -2)] ? h.slice(0, -2) : h;
          var want = color === COLORS_DE[1] && pieces[base + '-1'] ? base + '-1' : base;
          if (want === h || !pieces[want]) return sl;
          var n = newSlot(want); n.s1 = sl.s1; n.s2 = sl.s2; n.name = sl.name; changed = true; return n;
        });
        return changed;
      }

      // ---------- Events ----------
      function reveal() {
        state.revealed = true; state.chosen = true; if (stepsEl) stepsEl.hidden = false; if (flow) state.step = firstOpen(); syncAfter(); renderAllSlots(); renderTotals();
        requestAnimationFrame(function () {
          var t = [root.querySelector('[data-pg-flowtitle]'), root.querySelector('[data-pg-prog]'), stepsEl].filter(function (x) { return x && !x.hidden && x.offsetParent; })[0]; if (!t) return;
          var hh = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
          window.scrollTo({ top: Math.max(0, window.pageYOffset + t.getBoundingClientRect().top - hh - 16), behavior: 'smooth' });
        });
        var first = root.querySelector('[data-pg-initial="0-1"]'); if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (e) {} }, 450);
      }
      root.addEventListener('change', function (e) {
        var t = e.target;
        if (t.name === 'pg_size') { state.size = t.value; state.chosen = true; renderAll(); if (flow) syncSteps(); return; }
        if (t.hasAttribute('data-pg-color')) { var i = +t.getAttribute('data-pg-color'); slotAt(i).color = t.value; var cn = root.querySelector('[data-pg-colorname="' + i + '"]'); if (cn) cn.textContent = colorLabel(t.value); if (i === 0 && slotAt(0).handle === data.ring.handle) { switchGallery(t.value); if (boxFollowRing(t.value)) { if (state.size === 'box') { renderSlot(1); renderSlot(2); } renderInside(); } } renderCards(); renderTotals(); emitSlots(); return; }
        if (t.hasAttribute('data-pg-size')) { slotAt(+t.getAttribute('data-pg-size')).size = t.value; emitSlots(); return; }
        if (t.hasAttribute('data-pg-stone')) { var k = t.getAttribute('data-pg-stone').split('-'); slotAt(+k[0])['s' + k[1]] = t.value; if (t.value) t.setAttribute('aria-invalid', 'false'); emitSlots(); return; }
      });
      root.addEventListener('input', function (e) {
        var t = e.target;
        if (t.hasAttribute('data-pg-initial')) { var k = t.getAttribute('data-pg-initial').split('-'); t.value = t.value.replace(/[^A-Za-zÄÖÜäöüÉÈÇéèç]/g, '').toUpperCase().slice(0, 1); slotAt(+k[0])['i' + k[1]] = t.value; if (k[0] === '0') syncMirror(true); else if (k[0] === '1' && state.size === 'duo') slotAt(1).mirror = false; if (t.value) { t.setAttribute('aria-invalid', 'false'); if (k[1] === '1') { var nx = root.querySelector('[data-pg-initial="' + k[0] + '-2"]'); if (nx && !nx.value) nx.focus(); } } emitSlots(); return; }
        if (t.hasAttribute('data-pg-name')) { var nmx = +(t.getAttribute('maxlength') || 12); var cl = t.value.replace(/[^A-Za-zÄÖÜäöüßÀ-ÿ]/g, '').slice(0, nmx); if (cl !== t.value) t.value = cl; slotAt(+t.getAttribute('data-pg-name')).name = t.value; if (t.value.trim()) t.setAttribute('aria-invalid', 'false'); emitSlots(); return; }
      });
      root.addEventListener('click', function (e) {
        var cardEl = e.target.closest('[data-pg-card]'); if (cardEl && !state.chosen) { state.chosen = true; renderTotals(); }
        var lk = e.target.closest('[data-pg-look]'); if (lk) { e.preventDefault(); var sx = slotAt(+lk.getAttribute('data-pg-look')); if (sx) openQv(sx.handle); return; }
        var lh = e.target.closest('[data-pg-look-h]'); if (lh) { e.preventDefault(); openQv(lh.getAttribute('data-pg-look-h')); return; }
        var nx = e.target.closest('[data-pg-next]'); if (nx) { e.preventDefault(); advance(+nx.getAttribute('data-pg-next')); return; }
        var ed = e.target.closest('[data-pg-edit]'); if (ed) { e.preventDefault(); var w = ed.getAttribute('data-pg-edit'); if (w === 'size') { state.revealed = false; closePicker(); if (stepsEl) stepsEl.hidden = true; syncSteps(); renderTotals(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } else goStep(+w); return; }
        var ch = e.target.closest('[data-pg-change]'); if (ch) { e.preventDefault(); openPicker(+ch.getAttribute('data-pg-change')); return; }
        var pk = e.target.closest('[data-pg-pick]'); if (pk) { e.preventDefault(); var h = pk.getAttribute('data-pg-pick'); if (pickFor != null) { if (pickFor === 0) state.slots[0] = newSlot(h); else extraFor(state.size)[pickFor - 1] = newSlot(h); renderSlot(pickFor); } var back = pickFor; closePicker(); renderCards(); renderTotals(); if (back != null) showSlot(back); return; }
        if (e.target.closest('[data-pg-picker-close]')) { e.preventDefault(); var back2 = pickFor; closePicker(); if (back2 != null) showSlot(back2); return; }
        var chip = e.target.closest('[data-pg-chip]'); if (chip) { e.preventDefault(); var ta = root.querySelector('[data-pg-cardtext]'); if (ta) { ta.value = chip.textContent.trim(); ta.focus(); } return; }
        if (e.target.closest('[data-pg-submit]')) { e.preventDefault(); if (!state.revealed && noChoice()) { state.revealed = true; state.chosen = true; state.done[0] = true; state.step = activeSlots(); submit(); return; } if (!state.revealed) reveal(); else submit(); return; }
      });
      if (form) {
        form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); if (!state.revealed) reveal(); else submit(); }, true);
        form.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('input')) { e.preventDefault(); } }, true);
      }

      // ---------- Prüfen und in den Warenkorb ----------
      function showError(msg) { var b = root.querySelector('[data-pg-error]'); if (b) { b.textContent = msg; b.hidden = !msg; } }
      function validate() {
        var n = activeSlots(), firstBad = null, msg = '';
        function bad(el, m) { if (el) el.setAttribute('aria-invalid', 'true'); if (!firstBad) { firstBad = el; msg = m; } }
        for (var i = 0; i < n; i++) {
          var sl = slotAt(i), p = piece(sl.handle);
          if (p.type === 'initials') { if (!sl.i1) bad(root.querySelector('[data-pg-initial="' + i + '-1"]'), T.needInitials); if (!sl.i2) bad(root.querySelector('[data-pg-initial="' + i + '-2"]'), T.needInitials); }
          if (p.type === 'stones') { if (!sl.s1) bad(root.querySelector('[data-pg-stone="' + i + '-1"]'), T.needStones); if (!sl.s2) bad(root.querySelector('[data-pg-stone="' + i + '-2"]'), T.needStones); }
          if (p.type === 'name' && !sl.name.trim()) bad(root.querySelector('[data-pg-name="' + i + '"]'), T.needName);
        }
        if (firstBad) { showError(msg); firstBad.focus(); return false; }
        showError(''); return true;
      }
      // v3.45: Namen und Werte der Bestellangaben in der Sprache der Kundin (snippets/pm-props.liquid)
      var PP = window.pmProps || null;
      function pkey(c) { return PP ? PP.key(c) : c; }
      function pcol(v) { return PP ? PP.color(v) : v; }
      function pmon(v) { return PP ? PP.month(v) : v; }
      function properties() {
        var props = {}, n = activeSlots();
        for (var i = 0; i < n; i++) {
          var sl = slotAt(i), p = piece(sl.handle), k = 'Stück ' + (i + 1);
          var desc = [PP ? (p.label || p.orderLabel) : (p.orderLabel || p.label), pcol(sl.color), sl.size].filter(Boolean).join(' · ');
          if (i === 0 && sl.handle === data.ring.handle && p.type === 'initials') {
            if (sl.color) props[PP ? pkey('Farbe') : (state.size === 'duo' ? 'Farbe' : 'Ihr Ring')] = pcol(sl.color);
            props[pkey('1. Initiale')] = sl.i1; props[pkey('2. Initiale')] = sl.i2;
            if (n > 1) props[pkey('Stück 1')] = desc;
          } else if (i === 0 && sl.handle === data.ring.handle && n === 1) {
            if (p.type === 'stones') { props[pkey('Geburtsstein 1')] = pmon(sl.s1); props[pkey('Geburtsstein 2')] = pmon(sl.s2); }
            if (p.type === 'name') props[pkey('Name')] = sl.name.trim();
          } else {
            props[pkey(k)] = desc;
            if (p.type === 'initials') props[pkey(k + ' · Initialen')] = sl.i1 + ' + ' + sl.i2;
            if (p.type === 'stones') { props[pkey(k + ' · Geburtsstein 1')] = pmon(sl.s1); props[pkey(k + ' · Geburtsstein 2')] = pmon(sl.s2); }
            if (p.type === 'name') props[pkey(k + ' · Name')] = sl.name.trim();
          }
        }
        var ta = root.querySelector('[data-pg-cardtext]'); if (ta && ta.value.trim()) props[pkey('Kartentext')] = ta.value.trim();
        if (state.fromCart && state.size === 'box') props['_Upgrade'] = 'Warenkorb';
        return props;
      }
      function variantId() {
        if (state.size === 'ring') return ringVariant().id;
        if (state.size === 'duo') { var v = duoVariant(); return v ? v.id : null; }
        return data.box ? data.box.id : null;
      }
      function submit() {
        if (flow && state.revealed && !allDone()) { var o = firstOpen(); if (o < activeSlots()) { if (state.step !== o) goStep(o); validateSlot(o); } return; }
        if (!validate()) return;
        var id = variantId(); if (!id) { showError(T.notReady); return; }
        var items = [{ id: id, quantity: 1, properties: properties() }];
        if (addonActive()) {
          if (!state.addon.s1 || !state.addon.s2) { addonError(T.addonNeed || T.needStones || ''); try { addonEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} return; }
          var av = addonVariant(); if (av) items.push({ id: av.id, quantity: 1, properties: (function () { var ap = {}; ap[pkey('Geburtsstein 1')] = pmon(state.addon.s1); ap[pkey('Geburtsstein 2')] = pmon(state.addon.s2); ap['_Zusatz'] = 'Kaufbox'; return ap; })() });
        }
        var btn = root.querySelector('[data-pg-submit]'); if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
        var url = (form && form.dataset.cartAddUrl ? form.dataset.cartAddUrl : '/cart/add') + '.js';
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
            if (!res.ok) { showError((res.data && (res.data.description || res.data.message)) || T.cartErr || ''); return; }
            function go() {
              var after = (form && form.dataset.afterAdd) || 'cart';
              if (after === 'cart') window.location.href = (form && form.dataset.cartUrl) || '/cart';
              else if (after !== 'none') window.location.reload();
              document.dispatchEvent(new CustomEvent('pg:added', { detail: res.data }));
            }
            if (upRm && state.size === 'box') {
              var rk = upRm; upRm = null;
              var rr = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
              fetch(rr + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: rk, quantity: 0 }) })
                .then(function () { try { if (typeof window.upcartRefreshCart === 'function') return window.upcartRefreshCart(); } catch (e) {} }, function () {})
                .then(go, go);
            } else go();
          })
          .catch(function () { if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); } showError(T.network); });
      }

      // ---------- Upgrade aus dem Warenkorb ----------
      var upRm = null;
      (function () {
        var q; try { q = new URLSearchParams(window.location.search); } catch (e) { return; }
        if (q.get('pg_up') !== 'box' || !data.box) return;
        upRm = q.get('pg_rm') || null;
        var c = q.get('pg_c'), i1 = q.get('pg_i1'), i2 = q.get('pg_i2');
        try { ['pg_up', 'pg_c', 'pg_i1', 'pg_i2', 'pg_rm'].forEach(function (k) { q.delete(k); }); var qs = q.toString(); history.replaceState(history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash); } catch (e) {}
        state.size = 'box'; state.chosen = true; state.fromCart = true;
        var s0 = state.slots[0];
        if (c && (data.ring.colors || []).some(function (x) { return x.name === c; })) s0.color = c;
        function one(v) { return String(v || '').replace(/[^A-Za-zÄÖÜäöüÉÈÇéèç]/g, '').toUpperCase().slice(0, 1); }
        s0.i1 = one(i1); s0.i2 = one(i2);
        if (s0.i1 && s0.i2) state.done[0] = true;
        if (s0.color === COLORS_DE[1]) state.extra.box = state.extra.box.map(function (sl) { var h2 = sl.handle + '-1'; return pieces[h2] ? newSlot(h2) : sl; });
        renderAll(); syncAfter(); switchGallery(s0.color);
        setTimeout(reveal, 60);
      })();

      // ---------- Box-Ansicht für Anzeigen (19.10.2026) ----------
      // Link mit ?box=1 (Klasse pm-box am <html>, gesetzt in sections/main-product-custom): Geschenkbox vorgewählt.
      // Kein fromCart, also keine Angabe „_Upgrade: Warenkorb“. Die Adresse bleibt, UTM-Parameter bleiben drin.
      (function () {
        if (state.fromCart || !data.box || !document.documentElement.classList.contains('pm-box')) return;
        state.size = 'box'; state.chosen = true;
        renderAll(); syncAfter();
      })();

      renderAll(); syncAfter();
      window.__pg = {
        getState: function () { return { revealed: state.revealed && allDone(), chosen: state.chosen, size: state.size, price: priceText(state.size), headline: headlineText(), ring: state.slots[0].handle === data.ring.handle, color: state.slots[0].color, i1: state.slots[0].i1, i2: state.slots[0].i2 }; },
        reveal: reveal, submit: submit, getSlots: slotsDetail,
        stickyClick: function (btn) {
          if (!state.revealed) { state.chosen = true; reveal(); return; }
          if (flow && !allDone()) { var oo = firstOpen(); if (oo < activeSlots()) { if (state.step !== oo) goStep(oo); else advance(oo); } return; }
          if (!validate()) { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
          if (btn) { btn.classList.add('is-loading'); setTimeout(function () { btn.classList.remove('is-loading'); }, 4000); }
          submit();
        }
      };
      (function waitIg() { if (igReady()) return; var tries = 0; var t = setInterval(function () { tries++; if (igReady()) { clearInterval(t); renderAll(); } else if (tries > 12) clearInterval(t); }, 250); })();
    }
    function boot() { document.querySelectorAll('[data-pg]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-gravur"] && !Shopify.designMode) return;
  try {
    (function () {
    var cfg = null;
    function parseLines(txt, sep) { var o = {}; String(txt || '').split(/\r?\n/).forEach(function (l) { var i = l.indexOf(sep); if (i > 0) { var k = l.slice(0, i).trim(), v = l.slice(i + 1).trim(); if (k && v) o[k.toLowerCase()] = v; } }); return o; }
    function colorKey(name) { var n = String(name || '').toLowerCase(); if (n.indexOf('ros') >= 0) return 'rose'; if (n.indexOf('silb') >= 0 || n.indexOf('silver') >= 0) return 'silber'; return 'gold'; }
    function hexToRgb(h) { h = String(h || '').replace('#', ''); if (h.length === 3) h = h.replace(/(.)/g, '$1$1'); var n = parseInt(h, 16); if (isNaN(n)) return [160, 160, 160]; return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
    function mix(c, t, p) { return [Math.round(c[0] + (t[0] - c[0]) * p), Math.round(c[1] + (t[1] - c[1]) * p), Math.round(c[2] + (t[2] - c[2]) * p)]; }
    function rgb(c) { return 'rgb(' + c.join(',') + ')'; }
    function monthColor(value) {
      var v = String(value || '').toLowerCase(); if (!v) return null; var m = cfg.months;
      for (var k in m) { if (v.indexOf(k) >= 0) return m[k]; }
      return null;
    }
    function lookup(handle) {
      var h = String(handle || '').toLowerCase(); var e = cfg.mapParsed[h];
      if (e) { var parts = e.split(':'); return { p: parts[0].trim(), m: (parts[1] || 'gold').trim() }; }
      var p = h.indexOf('zia') >= 0 ? 'zia' : h.indexOf('elara') >= 0 ? 'elara' : h.indexOf('navae') >= 0 ? 'navae' : h.indexOf('toi') >= 0 ? 'toi' : null;
      if (!p) return null;
      return { p: p, m: (h.indexOf('silb') >= 0 || h.indexOf('silver') >= 0) ? 'silber' : 'gold' };
    }
    function stonePath(shape) {
      var vb = shape === 'emerald' ? '0 0 100 130' : shape === 'round' ? '0 0 100 100' : '0 0 100 140';
      var path = shape === 'emerald' ? '<path d="M18 0H82L100 18V112L82 130H18L0 112V18Z"/>' : shape === 'round' ? '<circle cx="50" cy="50" r="50"/>' : '<path d="M50 0C75 30 100 70 100 95A50 45 0 0 1 0 95C0 70 25 30 50 0Z"/>';
      return { vb: vb, path: path };
    }
    function stoneSvg(shape, color, style) {
      var p = stonePath(shape);
      return '<svg class="pv__stone" viewBox="' + p.vb + '" style="' + style + '" aria-hidden="true"><g fill="' + color + '">' + p.path + '</g></svg>'
           + '<svg class="pv__stone pv__stone--deep" viewBox="' + p.vb + '" style="' + style + '" aria-hidden="true"><g fill="' + color + '">' + p.path + '</g></svg>';
    }
    function renderRing(ph, sl) {
      var r = cfg.ring; var key = colorKey(sl.color); var src = r.images[key] || r.images.gold; if (!src) { ph.innerHTML = ''; return; }
      var i1 = String(sl.i1 || ''), i2 = String(sl.i2 || ''); if (r.upper) { i1 = i1.toUpperCase(); i2 = i2.toUpperCase(); }
      var html = '<div class="pv pv--ring' + (r.upper ? ' pv--upper' : '') + (r.engraved ? ' pv--engraved' : '') + '" style="--pv-ar:' + (r.ratio || cfg.ratio) + ';--pv-focus:' + r.focus + '%;--pv-radius:' + cfg.radius + 'px;--pv-border:' + cfg.border + ';--pv-font:' + r.font + ', ' + r.fallback + ';--pv-weight:' + r.weight + ';--pv-size:' + r.size + ';--pv-op:' + r.opacity + ';--pv-ph-op:' + r.phOpacity + ';--pv-ink:' + (r.colors[key] || r.colors.gold) + '">'
        + '<img class="pv__img" src="' + src + '" alt="" loading="lazy">'
        + '<span class="pv__l' + (i1 ? '' : ' is-ph') + '" style="--l-x:' + r.x1 + '%;--l-y:' + r.y1 + '%;--l-r:' + r.r1 + 'deg" aria-hidden="true">' + (i1 || r.ph1 || '') + '</span>'
        + '<span class="pv__l' + (i2 ? '' : ' is-ph') + '" style="--l-x:' + r.x2 + '%;--l-y:' + r.y2 + '%;--l-r:' + r.r2 + 'deg" aria-hidden="true">' + (i2 || r.ph2 || '') + '</span></div>';
      if (ph.getAttribute('data-pv-sig') !== html) { ph.setAttribute('data-pv-sig', html); ph.innerHTML = html; }
    }
    function monthNum(value) {
      var v = String(value || '').toLowerCase(); try { v = v.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {} v = v.replace(/[^a-z]/g, '');
      if (!v) return 0;
      var t = [['jan', 1], ['feb', 2], ['fev', 2], ['mar', 3], ['maa', 3], ['apr', 4], ['avr', 4], ['mai', 5], ['mei', 5], ['may', 5], ['juil', 7], ['juin', 6], ['jun', 6], ['jul', 7], ['aug', 8], ['aou', 8], ['sep', 9], ['okt', 10], ['oct', 10], ['nov', 11], ['dez', 12], ['dec', 12]];
      for (var i = 0; i < t.length; i++) { if (v.indexOf(t[i][0]) === 0) return t[i][1]; }
      return 0;
    }
    function esc(x) { return String(x == null ? '' : x).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function renderStoneTiles(ph, sl, e, p, isLast) {
      var file = function (shape) { return shape === 'emerald' ? 'rechteck' : 'tropfen'; };
      var metal = e.m === 'silber' ? 'silber' : 'gold'; var size = cfg.stoneSize || 56; var labels = cfg.stoneLabels || ['', ''];
      var html = '<div class="pvt" style="--pv-radius:' + cfg.radius + 'px;--pvt-zoom:' + (cfg.stoneZoom || 1.25) + ';--pvt-bg:' + (cfg.stoneBg || '#F7F4EE') + ';--pvt-size:' + size + 'px">';
      [['s1', sl.s1], ['s2', sl.s2]].forEach(function (pair, k) {
        var st = p[pair[0]] || { shape: 'pear' }; var n = monthNum(pair[1]); var nn = (n ? (n < 10 ? '0' + n : '' + n) : '04');
        var src = cfg.stoneBase + file(st.shape) + '-' + metal + '-' + nn + '.png?width=240';
        var name = n ? (cfg.stoneNamesParsed[nn] || cfg.stoneNamesParsed[String(n)] || '') : '';
        html += '<div class="pvt__tile' + (n ? '' : ' is-ph') + '"><span class="pvt__img"><img src="' + esc(src) + '" alt="" loading="eager"></span><span class="pvt__tx">' + (labels[k] ? '<small>' + esc(labels[k]) + '</small>' : '') + '<b>' + esc(n ? pair[1] : (cfg.stonePh || '')) + '</b>' + (name ? '<span>' + esc(name) + '</span>' : '') + '</span></div>';
      });
      if (cfg.stoneNote && isLast) html += '<p class="pvt__note">' + esc(cfg.stoneNote) + '</p>';
      html += '</div>';
      try { if (ph.parentNode) ph.parentNode.style.setProperty('--pvt-h', (size + 12) + 'px'); } catch (err) {}
      if (ph.getAttribute('data-pv-sig') !== html) { ph.setAttribute('data-pv-sig', html); ph.innerHTML = html; }
    }
    function renderStones(ph, sl, isLast) {
      var e = lookup(sl.handle); var p = e && cfg.stones[e.p]; if (!p) { ph.innerHTML = ''; return; }
      if (cfg.stoneMode !== 'photo' && cfg.stoneBase) { renderStoneTiles(ph, sl, e, p, isLast); return; }
      var src = p.images[e.m] || p.images.gold || p.images.silber; if (!src) { ph.innerHTML = ''; return; }
      var html = '<div class="pv pv--stones" style="--pv-ar:' + cfg.ratio + ';--pv-focus:' + p.focus + '%;--pv-radius:' + cfg.radius + 'px;--pv-border:' + cfg.border + ';--pv-stone-op:' + cfg.stoneOpacity + '"><img class="pv__img" src="' + src + '" alt="" loading="lazy">';
      [['s1', sl.s1], ['s2', sl.s2]].forEach(function (pair, k) {
        var st = p[pair[0]], col = monthColor(pair[1]); if (!st || !col) return;
        html += stoneSvg(st.shape, col, '--s-x:' + st.x + '%;--s-y:' + st.y + '%;--s-w:' + st.w + '%;--s-r:' + st.rot + 'deg');
      });
      html += '</div>';
      if (ph.getAttribute('data-pv-sig') !== html) { ph.setAttribute('data-pv-sig', html); ph.innerHTML = html; }
    }
    function renderAll(detail) {
      if (!cfg || !detail || !detail.slots) return;
      var lastStone = -1; detail.slots.forEach(function (x) { if (x.type === 'stones') lastStone = x.i; });
      detail.slots.forEach(function (sl) {
        var ph = document.querySelector('[data-pg-preview-slot="' + sl.i + '"]'); if (!ph) return;
        if (sl.type === 'initials') renderRing(ph, sl); else if (sl.type === 'stones') renderStones(ph, sl, sl.i === lastStone); else { ph.innerHTML = ''; ph.removeAttribute('data-pv-sig'); }
      });
    }
    function boot() {
      var node = document.querySelector('[data-pm-preview-config]'); if (!node || node.dataset.ready) return; node.dataset.ready = '1';
      try { cfg = JSON.parse(node.textContent); } catch (e) { return; }
      try { ['gold', 'silber', 'rose'].forEach(function (k) { var u = cfg.ring && cfg.ring.images && cfg.ring.images[k]; if (u) { var im = new Image(); im.src = u; } }); } catch (e) {}
      cfg.mapParsed = parseLines(cfg.map, '='); cfg.months = parseLines(cfg.monthColors, '='); cfg.stoneNamesParsed = parseLines(cfg.stoneNames, '=');
      document.addEventListener('pg:slots', function (e) { renderAll(e.detail); });
      if (window.__pg && window.__pg.getSlots) renderAll(window.__pg.getSlots());
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pm-sticky-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(bar) {
      if (bar.dataset.ready) return; bar.dataset.ready = '1';
      var btn = bar.querySelector('[data-pm-sticky-btn]');
      var priceEl = bar.querySelector('[data-pm-sticky-price]');
      var lblEl = bar.querySelector('.pm-sticky__lbl');
      var lblDefault = lblEl ? lblEl.textContent : '';
      var follow = bar.dataset.follow === '1';
      var cmpEl = bar.querySelector('[data-pm-sticky-compare]');
      var labelSelect = bar.dataset.labelSelect || 'Weiter';
      var labelCart = bar.dataset.labelCart || 'In den Warenkorb';
      var state = { revealed: false, price: '', headline: '', compare: '', addon: false };
      function selCard() { return document.querySelector('[data-pg] .pg-card.is-on') || document.querySelector('.pg-card.is-on'); }
      function txt(el) { return el && !el.hidden ? (el.textContent || '').trim() : ''; }
      function render() {
        var card = follow ? selCard() : null;
        if (card) {
          var cPrice = txt(card.querySelector('.pg-card__p b'));
          var cCmp = state.addon ? '' : txt(card.querySelector('.pg-card__p s'));
          if (lblEl) lblEl.textContent = txt(card.querySelector('.pg-card__t b')) || lblDefault;
          if (priceEl) priceEl.textContent = state.price || cPrice || state.headline;
          if (cmpEl) { cmpEl.textContent = cCmp; cmpEl.hidden = !cCmp; }
        } else {
          if (lblEl) lblEl.textContent = lblDefault;
          if (priceEl) priceEl.textContent = state.headline || state.price;
          if (cmpEl) { cmpEl.textContent = state.compare; cmpEl.hidden = !state.compare; }
        }
        if (btn) btn.textContent = (state.revealed ? labelCart : labelSelect).replace('{price}', state.price);
      }
      function take(d) { d = d || {}; state.revealed = !!d.revealed; state.price = d.price || ''; state.headline = d.headline || ''; state.compare = d.compare || ''; state.addon = !!d.addon; }
      document.addEventListener('pg:state', function (e) { take(e.detail); render(); });
      if (btn) btn.addEventListener('click', function () {
        var api = window.__pg; if (!api) { var k = document.getElementById('kauf'); if (k) k.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        api.stickyClick(btn);
      });
      function setActive(active) {
        bar.hidden = false;
        bar.classList.toggle('is-off', !active);
        var mobileOnly = bar.classList.contains('pm-sticky--mobile');
        var pads = active && (!mobileOnly || !matchMedia('(min-width: 990px)').matches);
        document.body.classList.toggle('pm-sticky-on', pads);
      }
      function watch() {
        var mode = bar.dataset.showAfter || 'tiles';
        var sel = mode === 'tiles' ? '.pm-tiles' : mode === 'box' ? '[data-pg]' : mode === 'button' ? '[data-pg-submit]' : null;
        var target = sel ? (document.querySelector(sel) || document.querySelector('[data-pg-submit]')) : null;
        if (!target || !('IntersectionObserver' in window)) { setActive(true); return; }
        var io = new IntersectionObserver(function (entries) {
          var en = entries[entries.length - 1];
          var passed = !en.isIntersecting && en.boundingClientRect.bottom <= 0;
          setActive(passed);
        }, { threshold: 0 });
        io.observe(target);
      }
      watch();
      if (window.__pg && window.__pg.getState) take(window.__pg.getState());
      render();
    }
    function boot() { document.querySelectorAll('[data-pm-sticky]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-rating"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-rating]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';
        el.addEventListener('click', function () {
          var target = el.getAttribute('data-target');
          if (!target) return;
          var dest = document.querySelector(target);
          if (dest) dest.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-birthstone-ring"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');
        var gems = bindModal('[data-pm-gems]', '[data-pm-gems-open]', '[data-pm-gems-close]');

        var confirmBtn = el.querySelector('[data-pm-gems-confirm]');
        if (confirmBtn && gems) confirmBtn.addEventListener('click', gems.close);

        // Größen-Label
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });

        // ---- Geburtssteine ----
        function checked(name) { return el.querySelector('input[name="' + name + '"]:checked'); }

        function setPreview(idx, input) {
          el.querySelectorAll('[data-pm-preview="' + idx + '"]').forEach(function (w) {
            w.textContent = '';
            if (input && input.dataset.img) {
              var img = document.createElement('img');
              img.src = input.dataset.img;
              img.alt = '';
              w.appendChild(img);
            }
          });
        }

        function updateGems() {
          var i1 = checked('pm_stone1');
          var i2 = checked('pm_stone2');
          var n = (i1 ? 1 : 0) + (i2 ? 1 : 0);

          el.querySelectorAll('[data-pm-gems-count]').forEach(function (c) { c.textContent = n + '/2'; });
          setPreview(1, i1);
          setPreview(2, i2);

          if (confirmBtn) confirmBtn.disabled = n !== 2;

          var foot = el.querySelector('[data-pm-gems-foot]');
          if (foot) foot.textContent = n + '/2 ' + (el.dataset.footNote || '');

          var trigger = el.querySelector('[data-pm-gems-open]');
          if (trigger) trigger.classList.toggle('is-complete', n === 2);

          var summary = el.querySelector('[data-pm-gems-summary]');
          if (summary) {
            if (n === 0) { summary.hidden = true; summary.textContent = ''; return; }
            summary.hidden = false;
            summary.textContent = '';
            if (i1) {
              summary.appendChild(document.createTextNode('1: '));
              var b1 = document.createElement('strong'); b1.textContent = i1.value; summary.appendChild(b1);
            }
            if (i1 && i2) summary.appendChild(document.createTextNode(' · '));
            if (i2) {
              summary.appendChild(document.createTextNode('2: '));
              var b2 = document.createElement('strong'); b2.textContent = i2.value; summary.appendChild(b2);
            }
          }
        }

        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-stone]')) updateGems();
        });
        updateGems();
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-gemstones"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');
        var gems = bindModal('[data-pm-gems]', '[data-pm-gems-open]', '[data-pm-gems-close]');

        var confirmBtn = el.querySelector('[data-pm-gems-confirm]');
        if (confirmBtn && gems) confirmBtn.addEventListener('click', gems.close);

        // Größen-Label
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });

        // ---- Geburtssteine ----
        function checked(name) { return el.querySelector('input[name="' + name + '"]:checked'); }

        function setPreview(idx, input) {
          el.querySelectorAll('[data-pm-preview="' + idx + '"]').forEach(function (w) {
            w.textContent = '';
            if (input && input.dataset.img) {
              var img = document.createElement('img');
              img.src = input.dataset.img;
              img.alt = '';
              w.appendChild(img);
            }
          });
        }

        function updateGems() {
          var i1 = checked('pm_stone1');
          var i2 = checked('pm_stone2');
          var n = (i1 ? 1 : 0) + (i2 ? 1 : 0);

          el.querySelectorAll('[data-pm-gems-count]').forEach(function (c) { c.textContent = n + '/2'; });
          setPreview(1, i1);
          setPreview(2, i2);

          if (confirmBtn) confirmBtn.disabled = n !== 2;

          var foot = el.querySelector('[data-pm-gems-foot]');
          if (foot) foot.textContent = n + '/2 ' + (el.dataset.footNote || '');

          var trigger = el.querySelector('[data-pm-gems-open]');
          if (trigger) trigger.classList.toggle('is-complete', n === 2);

          var summary = el.querySelector('[data-pm-gems-summary]');
          if (summary) {
            if (n === 0) { summary.hidden = true; summary.textContent = ''; return; }
            summary.hidden = false;
            summary.textContent = '';
            if (i1) {
              summary.appendChild(document.createTextNode('1: '));
              var b1 = document.createElement('strong'); b1.textContent = i1.value; summary.appendChild(b1);
            }
            if (i1 && i2) summary.appendChild(document.createTextNode(' · '));
            if (i2) {
              summary.appendChild(document.createTextNode('2: '));
              var b2 = document.createElement('strong'); b2.textContent = i2.value; summary.appendChild(b2);
            }
          }
        }

        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-stone]')) updateGems();
        });
        updateGems();
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-groesse"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');

        // ---- Größen-Label live ----
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variants-stackable-name-ring"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(root) {
      (root || document).querySelectorAll('[data-pm-brs]').forEach(function (el) {
        if (el.dataset.pmReady) return;
        el.dataset.pmReady = '1';

        function bindModal(modalSel, openSel, closeSel) {
          var modal = el.querySelector(modalSel);
          if (!modal) return null;
          function open() { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
          function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }
          el.querySelectorAll(openSel).forEach(function (b) { b.addEventListener('click', open); });
          el.querySelectorAll(closeSel).forEach(function (b) { b.addEventListener('click', close); });
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && !modal.hidden) close();
          });
          return { open: open, close: close };
        }

        bindModal('[data-pm-size-guide]', '[data-pm-size-guide-open]', '[data-pm-size-guide-close]');

        // ---- Größen-Label live ----
        el.addEventListener('change', function (e) {
          if (e.target.matches('[data-pm-size]')) {
            var t = el.querySelector('[data-pm-brs-size-name]');
            if (t) t.textContent = e.target.value;
          }
        });

        // ---- Namensfeld: Filter + Zähler ----
        var nameInput = el.querySelector('[data-pm-name]');
        if (nameInput) {
          var counter = el.querySelector('[data-pm-name-counter]');
          var maxLen = parseInt(nameInput.getAttribute('maxlength'), 10) || 12;
          var lettersOnly = nameInput.getAttribute('data-letters-only') === '1';
          var toUpper = nameInput.getAttribute('data-uppercase') === '1';

          function sanitizeName() {
            var v = nameInput.value;
            if (lettersOnly) {
              // erlaubt: Buchstaben (inkl. Umlaute/Akzente), Leerzeichen, Bindestrich, Apostroph
              try { v = v.replace(/[^\p{L} '\-]/gu, ''); }
              catch (err) { v = v.replace(/[^A-Za-zÀ-ÿ '\-]/g, ''); }
            }
            if (toUpper) v = v.toUpperCase();
            if (v.length > maxLen) v = v.slice(0, maxLen);

            if (v !== nameInput.value) {
              var pos = nameInput.selectionStart;
              nameInput.value = v;
              try { nameInput.setSelectionRange(pos, pos); } catch (e) {}
            }
            if (counter) {
              counter.textContent = v.length + '/' + maxLen;
              counter.classList.toggle('is-full', v.length >= maxLen);
            }
          }

          nameInput.addEventListener('input', sanitizeName);
          sanitizeName();
        }
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
